import { cn } from '@/lib/utils';
import { SimboloAC3D } from '@/components/marca/SimboloAC3D';

interface AppLogoProps {
  /** Menu recolhido: só o símbolo. */
  collapsed?: boolean;
  /**
   * `grande`: o símbolo em relevo, com o nome embaixo (login e telas de
   * conta). O padrão é a assinatura do menu: símbolo e nome lado a lado.
   */
  tamanho?: 'padrao' | 'grande';
  className?: string;
}

/** O nome da marca: "AC3D" forte e "Studio" na cor do símbolo. */
function NomeDaMarca({ className }: { className?: string }) {
  return (
    <span className={cn('font-headline font-bold leading-none tracking-tight', className)}>
      AC3D<span className="font-semibold text-marca">Studio</span>
    </span>
  );
}

export function AppLogo({ collapsed = false, tamanho = 'padrao', className }: AppLogoProps) {
  if (tamanho === 'grande') {
    return (
      <div className={cn('flex flex-col items-center gap-3', className)}>
        <SimboloAC3D relevo className="h-24 w-auto" rotulo="" />
        <NomeDaMarca className="text-xl text-foreground" />
      </div>
    );
  }

  if (collapsed) {
    return (
      <div className={cn('flex w-full items-center justify-center', className)}>
        <SimboloAC3D className="h-8 w-auto shrink-0" />
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <SimboloAC3D className="h-9 w-auto shrink-0" rotulo="" />
      <NomeDaMarca className="truncate text-lg text-sidebar-foreground transition-all duration-300" />
    </div>
  );
}
